export default __webpack_public_path__ + "static/media/frame.353e36b5.png";